<template>
  <v-container
    class="mx-0"
    fluid
  >

  <v-row>
    <v-col>
      <custom-location-list>
      </custom-location-list>
    </v-col>
    <v-col>
      <v-card :width="width">
        <v-card-title primary-title>
          Upload an Excel or CSV file of locations
        </v-card-title>
        <v-card-text>
          <uploader :row-limit="uploadLimit"/>
        </v-card-text>
      </v-card>
      <v-card border-color="yellow" class="mt-6">
        <div>
          <v-card-title>
            About
          </v-card-title>
          <v-card-text>
              Upload custom locations to generate climate risk and social impact metrics for locations not currently in CMBS deals and properties can be created by uploading a list of location groups.
              <ul>
                <li>Download the template below for required fields and column layout</li>
                <li>Required columns per location are lat/long coordinates and a name</li>
                <li>Optional columns include an amount (for weighting the group as a whole), address, and notes fields</li>
                <li><code>.xlsx</code> and <code>.csv</code> files supported</li>
              </ul>
              <v-banner class="text-md-right">
                <div style="color:#666">Upload row limit <v-chip v-text="uploadLimit" class="ml-2" dense outlined color="#666"></v-chip></div>
              </v-banner>
          </v-card-text>
          <v-card-actions>
            <v-btn outlined color="info" href="/lvl11_custom_loc_template.xlsx">Download template</v-btn>
          </v-card-actions>
          <v-divider></v-divider>
        </div>
      </v-card>
    </v-col>
  </v-row>


  <div v-for="id in myLocationIds" :key="id">
  <snackbar-message :show="changed[id]" :message="messages[id]" @closeSnackbar="()=>resetChanged(id)"/>


  <snackbar-message :show="uploadedLocation === id" message="Upload successful! We'll notify you when generation is complete. This may take several minutes." @closeSnackbar="()=>runPostUploadFunctions(id)"/>

    </div>
  </v-container>
</template>
<script>
import CustomLocationUploader from '@/components/Uploader.vue'
import CustomLocationList from '@/components/CustomLocationList.vue'
import SnackbarMessage from '@/components/SnackbarMessage'
import { mapGetters, mapState } from 'vuex'
import {getLocationGroups} from '@/utils/locations.js'
import {get, set} from '@/utils/utils'


export default {
    data(){
        return {
            refresh: false,
            changed: {},
            messages: {}
        }
    },
  components: {
    'uploader': CustomLocationUploader,
    'custom-location-list': CustomLocationList,
    'snackbar-message': SnackbarMessage

  },
  computed: {
    width(){

         switch (this.$vuetify.breakpoint.name) {
          case 'xs': return 300
          case 'sm': return 420
          case 'md': return 450
          case 'lg': return 550
          case 'xl': return 800
        }
        },
    ...mapGetters({
      uploadLimit: 'customLocationUploadLimit'
    }),


    ...mapState({
        uploadedLocation: 'uploadedLocation',
        locationGroups: 'locationGroups',
        myLocationGroups: 'myLocationGroups',
        sharedLocationGroups: 'sharedLocationGroups',
        locationScope: 'locationScope'
    }),
    myLocationIds(){
        return this.myLocationGroups.map(x=>x.id)
    }
  },
  methods: {
    runLocationGenerationCheck(){


        let locationsToCheck = get('locationsToCheck')||[]
       // set('locationsToCheck', [])
        // console.log('the locations to check are', locationsToCheck)

        //1. add any additional elements to locations to check

        getLocationGroups(this.locationScope)
        .then(res => {
            let groups = res.data;
            //only notify users if status changes for their locations, not shared ones
            if(this.locationScope === 'mine'){
            groups.forEach(group => {
                let id = group.id
                let foundGroup = locationsToCheck.find(x=> x.id ===id)
                let stage = group.processing_stage;
                if(stage !== 'Complete' && !foundGroup){
                    locationsToCheck.push(group)
                    set('locationsToCheck', locationsToCheck)

               }
            }

            )
            }

        })

        //2. set intervals for all locations to check


        locationsToCheck.forEach(group =>
        {
            // console.log(group.name, 'is at', group.processing_stage)
            let stage = group.processing_stage;
            let id = group.id;

            let intervalId = setInterval(()=> {
                // console.log('in interval', intervalId, group.name)
                getLocationGroups(this.locationScope)
                .then(res=>{
                    let groups = res.data;
                    let newGroup = groups.find(x=> x.id ===id);


                    if(newGroup){

                        let newStage = newGroup.processing_stage
                        // console.log(group.name, 'new', newStage, 'old', stage)
                    if(newStage ==='Complete'){

                        this.messages[id] = `Location group "${newGroup.name}" has finished generating`
                        // console.log(`at start of interval, have`, id, this.changed[id])

                        //shows snackbar message
                        //need a setter because id isn't initialized as a key in this.changed
                        this.$set(this.changed, id, true)


                        // console.log(`stage changed from ${stage} to ${newStage}`)

                        //update locations from storage in case functon in another interval has already removed some locations
                        //(this handles the case of two snackbars popping up one right after another)
                        locationsToCheck = get('locationsToCheck')||[]

                        locationsToCheck = locationsToCheck.filter(x=> x.id !== id );
                        // console.log(`first it's ${locationsToCheck.map(x=>x.name)}`)
                        set('locationsToCheck', locationsToCheck)
                        //console.log(`then it's `)
                        // console.log(`group ${newGroup.id} has finished processing`)
                        clearInterval(intervalId)
                    }
                   else if(newStage != stage){

                   // // this is for testing purposes, comment out later:

                        // this.$set(this.changed, id, true)
                        // this.$set(this.m essages, id,`stage of ${newGroup.name} changed from ${stage} to ${newStage}`)

                    //    console.log(`stage of ${newGroup.name} changed from ${stage} to ${newStage}`)

                    //update processing_stage in locationGroups for next interval run

                        this.getLocationGroups(this.locationScope);
                        stage = newStage;
                        group['processing_stage']= stage;
                        // console.log('to check', locationsToCheck);
                        let indexToModify = locationsToCheck.indexOf(x=>x.id===id);

                        locationsToCheck = locationsToCheck.map((x,i)=> {return i===indexToModify? group:x})

                        // locationsToCheck.group.processing_stage = stage;
                        set('locationsToCheck', locationsToCheck)
                        // console.log('now', get('locationsToCheck'))

                   }


                    }

                }
                )
            }, 60000 )
        }
        )

    },
    getLocationGroups(scope){
        this.refresh = false;
        //console.log('getting location groups', 'scope is', scope, 'in store, sharedLocationGroups are', this.$store.state.sharedLocationGroups)
        getLocationGroups(scope)
        .then(res => {

            let groups = res.data
             if(groups.length === 0) {
                if(this.locationScope === 'mine') {
                    this.$store.dispatch('updateState', ['noMyLocationGroups', true])
                }
                else {
                    this.$store.dispatch('updateState', ['noSharedLocationGroups', true])
                }
            }
             else {
                    if(this.locationScope === 'mine') {
                        this.$store.dispatch('updateState', ['noMyLocationGroups', false])
                    }
                    else {
                        this.$store.dispatch('updateState', ['noSharedLocationGroups', false])
                    }
                }
            //console.log('after api call, with scope', scope, groups)
            groups.forEach(group => {
                group.formId = `form-${group.id}`
            })
        //console.log(res.data);
        //console.log('location scope is', this.locationScope)
        // if(this.locationScope ==='mine'){
        //     this.$store.dispatch('updateState', ['myLocationGroups', groups])
        // }
        // else{
        //      this.$store.dispatch('updateState', ['sharedLocationGroups', groups])
        // }
        this.locationScope === 'mine'? this.$store.dispatch('updateState', ['myLocationGroups', groups]): this.$store.dispatch('updateState', ['sharedLocationGroups', groups])
       // console.log('dispatched store change')

       // console.log('and now sharedlocationgroups are', this.sharedLocationGroups, 'my location groups are', this.myLocationGroups)
        this.refresh = true;
        //console.log(`this.refresh is`, this.refresh)
        //console.log('the store sees', this.$store.state.locationGroups)
    })
    },
    runPostUploadFunctions(id){
        //hides message
        //and runs uploadedLocation watcher
        //which regenerates locations

        this.$store.dispatch('updateState', ['uploadedLocation', null]);
        //the new location will be under mine because it's just been uploaded
        getLocationGroups('mine')
        .then(res => {

             //1. push group with this id to locationsToCheck
            let groups = res.data;
            let group = groups.find(x=>x.id === id);

            let locationsToCheck = get('locationsToCheck')||[]
            locationsToCheck.push(group)
            set('locationsToCheck', locationsToCheck)

             //2. create interval for this location

            //   console.log(group.name, 'is at', group.processing_stage)
            let stage = group.processing_stage;

            let intervalId = setInterval(()=> {
                // console.log('in interval', intervalId, group.name)
                getLocationGroups(this.locationScope)
                .then(res=>{
                    let groups = res.data;
                    let newGroup = groups.find(x=> x.id ===id);


                    if(newGroup){

                        let newStage = newGroup.processing_stage
                        // console.log(group.name, 'new', newStage, 'old', stage)
                    if(newStage ==='Complete'){

                        this.messages[id] = `Location group "${newGroup.name}" has finished generating`
                        // console.log(`at start of interval, have`, id, this.changed[id])
                        this.$set(this.changed, id, true)



                        // console.log(`stage changed from ${stage} to ${newStage}`)

                        //update locations from storage in case functon in another interval has already removed some
                        locationsToCheck = get('locationsToCheck')||[]

                        locationsToCheck = locationsToCheck.filter(x=> x.id !== id );
                        // console.log(`first it's ${locationsToCheck.map(x=>x.name)}`)
                        set('locationsToCheck', locationsToCheck)
                        clearInterval(intervalId)
                    }
                   else if(newStage != stage){

                    // //this is for testing purposes, comment out later
                    //     this.$set(this.changed, id, true)
                    //     this.$set(this.messages, id,`stage of ${newGroup.name} changed from ${stage} to ${newStage}`)

                    //    console.log(`stage of ${newGroup.name} changed from ${stage} to ${newStage}`)

                        this.getLocationGroups(this.locationScope);
                        stage = newStage;
                        group['processing_stage']= stage;
                        // console.log('to check', locationsToCheck);
                        let indexToModify = locationsToCheck.indexOf(x=>x.id===id);

                        locationsToCheck = locationsToCheck.map((x,i)=> {return i===indexToModify? group:x})

                        // locationsToCheck.group.processing_stage = stage;
                        set('locationsToCheck', locationsToCheck)
                        // console.log('now', get('locationsToCheck'))

                   }


                    }

                }
                )
            }, 60000 )


        }

        )
    },
    resetChanged(id){
        this.$set(this.changed, id, false)
        this.getLocationGroups(this.locationScope);
    }
  },
  mounted(){
   // set('locationsToCheck', [])
    this.getLocationGroups(this.locationScope);
    this.runLocationGenerationCheck()
  },
  watch: {
    uploadedLocation(newVal){
        this.getLocationGroups(this.locationScope)
    },
    locationScope(newVal){
        this.getLocationGroups(newVal)
    }


  }

}
</script>
